import React from "react";
import { ChartMonthLabels } from "./ChartMonthLabels";
import { RainfallButtons } from "./RainfallButtons";
import { RainfallGraph } from "./RainfallGraph";
import { MonthlyWeather } from "./types";

type RainfallChartProps = {
    monthlyWeather: MonthlyWeather;
};

export const RainfallChart: React.FC<RainfallChartProps> = ({
    monthlyWeather,
}) => {
    return (
        <>
            <RainfallButtons />
            <RainfallGraph monthlyWeather={monthlyWeather} />
            <ChartMonthLabels />
        </>
    );
};
